import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';

import AppContent from './components/AppContent';
import MetaTags from './components/MetaTags';
import { ThemeProvider } from './theme';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ThemeProvider>
          <div className="App">
            <MetaTags />
            <AppContent />
          </div>
        </ThemeProvider>
      </Router>
    </HelmetProvider>
  );
}

export default App;
